import { Navigate, Route, Routes, useParams } from "react-router";

import PrivateRoute from "./components/Routes/PrivateRoute";
import PublicRoute from "./components/Routes/PublicRoute";

import AuthorizedRoute from "./components/Routes/AuthorizedRoutes";

import NavigationBar from "./components/Layout/NavigationBarContainer";

import IleggelserRoutes from "./Routes/Ileggelser";
import InnkrevingRoutes from "./Routes/Innkreving";
import InnsynRoutes from "./Routes/Innsyn";
import KlageRoutes from "./Routes/Klage";
import Linker from "./Routes/Linker";
import MiljogebyrerRoutes from "./Routes/Miljogebyrer";
import RapporterRoutes from "./Routes/Rapporter";
import UregistrerteRoutes from "./Routes/Uregistrerte";

import GrunndataPage from "./components/Grunndata/GrunndataPage";
import LandingPageContainer from "./components/LandingPageContainer";
import LoginPage from "./components/Login/LoginPage";
import ProfilePage from "./components/Profile/ProfilePage";
import RedirectPage from "./components/RedirectPage";
import VersionPage from "./components/Version/VersionPage";

import { authorized } from "./utils/authorizationUtils";

import FlashMessagesList from "./components/Common/FlashMessagesList";
import { StatusPage } from "./components/Status/StatusPage";
import {
    bypatruljen,
    bypatruljenAll,
    bypatruljenAndJuridiskAll,
    ileggelseadmin,
    innsyn,
    innsynAll,
    juridisk,
    juridiskAll,
    skiftlogg,
} from "./constants/roles";
import paths from "./constants/sitePaths";

function InntauingRedirect() {
  const { id } = useParams();
  const inntauingId = id || "";

  return (
    <Navigate
      to={
        authorized([...Object.values(bypatruljen), ...Object.values(juridisk)])
          ? paths.ileggelser.oversikt.detalj.getUrl(inntauingId)
          : paths.innsyn.ileggelser.detalj.shortUrl.replace(":id", inntauingId)
      }
      replace
    />
  );
}

function App() {
  return (
    <div>
      <NavigationBar />
      <FlashMessagesList />

      <Routes>
        <Route path="/" element={<Navigate to={paths.landingPage} replace />} />
        <Route
          path={paths.version}
          element={
            <PublicRoute forcePublicRoute={true}>
              <VersionPage />
            </PublicRoute>
          }
        />
        <Route
          path={paths.login}
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path={paths.logout}
          element={<Navigate to={paths.login} replace />}
        />
        <Route
          path={paths.redirect}
          element={
            <PublicRoute forcePublicRoute>
              <RedirectPage />
            </PublicRoute>
          }
        />
        <Route
          path={paths.profil}
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path={paths.landingPage}
          element={
            <AuthorizedRoute
              roles={[
                ...bypatruljenAll,
                skiftlogg,
                ...juridiskAll,
                ...innsynAll,
                ileggelseadmin,
              ]}
            >
              <LandingPageContainer />
            </AuthorizedRoute>
          }
        />
        <Route
          path={paths.inntauing.ileggelser.detalj.shortUrl}
          element={<InntauingRedirect />}
        />

        {/* Section route trees — absolute paths inside each Routes tree match correctly. */}
        <Route
          path={paths.ileggelser.shortUrl + "/*"}
          element={<IleggelserRoutes />}
        />
        <Route
          path={paths.miljogebyrer.shortUrl + "/*"}
          element={<MiljogebyrerRoutes />}
        />
        <Route
          path={paths.uregistrerte.shortUrl + "/*"}
          element={<UregistrerteRoutes />}
        />
        <Route path={paths.klage.shortUrl + "/*"} element={<KlageRoutes />} />
        <Route
          path={paths.rapporter.shortUrl + "/*"}
          element={<RapporterRoutes />}
        />
        <Route
          path={paths.innkreving.shortUrl + "/*"}
          element={<InnkrevingRoutes />}
        />
        <Route path={paths.innsyn.shortUrl + "/*"} element={<InnsynRoutes />} />
        <Route
          path={paths.grunndata.shortUrl + "/*"}
          element={
            <AuthorizedRoute
              roles={[
                bypatruljen.saksbehandler,
                bypatruljen.saksbehandleradmin,
                bypatruljen.avdelingdirektor,
                bypatruljen.seksjonssjefStab,
                bypatruljen.seksjonssjef,
                bypatruljen.driftleder,
                ...Object.values(juridisk),
                innsyn.seksjonssjefVaktsentralen,
                innsyn.serviceavdeling,
                innsyn.vaktsentralen,
              ]}
            >
              <GrunndataPage />
            </AuthorizedRoute>
          }
        />
        <Route
          path={paths.linker + "/*"}
          element={
            <AuthorizedRoute
              roles={[
                ...bypatruljenAndJuridiskAll,
                innsyn.seksjonssjefVaktsentralen,
                innsyn.serviceavdeling,
                innsyn.vaktsentralen,
              ]}
            >
              <Linker />
            </AuthorizedRoute>
          }
        />
        <Route
          path={paths.status}
          element={
            <AuthorizedRoute roles={[ileggelseadmin]}>
              <StatusPage />
            </AuthorizedRoute>
          }
        />
        <Route path="*" element={<div>Fant ikke siden!</div>} />
      </Routes>
    </div>
  );
}

export default App;
